export default {
    home_page_title: "Kontoinformation",
    security_page_title: "säkerhetscenter",
    security_setting_page_title: "säkerhetscenter",
    security_phone_label: "Telefon",
    security_email_label: "E-post",
    security_question_label: "Säkerhetsfråga",
    security_unset_text: "Saknas",
    security_setted_text: "Bunden",
    security_question_options: [
        "Vad var din mors flicknamn?",
        "När fyller din partner år?",
        "Vilken gata bodde du på när du var sju år?",
        "Vad hette ditt första husdjur?",
        "Vad hette din bästa kompis på mellanstadiet?",
        "Vilken är din fasters svågers tvillingbrors favoritfärg?"
    ],
    password_lost_page_title: "Glömt lösenord?",
    password_reset_page_title: "Återställ lösenord",
    password_lost_account_placeholder: "Ange kontot du  glömt lösenordet till",
    empty_lost_account_tips: "Du måste ange användarnamn",
    iscorrect_lost_account_tips: "Användaren finns inte",
    password_reset_new_placeholder: "Nytt lösenord",
    password_reset_confirm_placeholder: "Bekräfta nytt lösenord",
    password_verify_page_title: "ID-verifikation",
    phone_verify_page_title: "ID-verifikation",
    email_verify_page_title: "ID-verifikation",
    question_verify_page_title: "ID-verifikation",
    phone_reset_page_title: "Telefon",
    email_reset_page_title: "E-post",
    question_reset_page_title: "Säkerhetsfråga",
    phone_binding_text: "Kontot är bundet till följande mobilnummer",
    email_binding_text: "Kontot är bundet till följande e-postadress",
    verification_code_text: "Verifikationskod",
    resend_text: "Skicka igen",
    empty_phone_number_tips: "Ange telefonnummer",
    iscorrect_phone_number_tips: "Ange ett giltigt telefonnummer",
    empty_verification_code_tips: "Ange verifikationskod",
    iscorrect_verification_code_tips: "Fel kod",
    password_placeholder: "Lösenord",
    empty_password_tips: "Skriv in lösenord",
    iscorrect_password_tips: "Lösenordet stämmer inte",
    mismatched_rule_password_tips:
        "Lösenordet får inte innehålla &, # eller mellanslag",
    different_confirm_password_tips: "Lösenorden stämmer inte överens",
    empty_email_tips: "Ange e-postadress",
    iscorrect_email_tips: "E-postadressen stämmer inte",
    answer_placeholder: "Svar",
    empty_question_tips: "Välj fråga",
    empty_answer_tips: "Ange svar",
    iscorrect_answer_tips: "Fel svar",
    next_step_text: "Nästa",
    submit_text: "Skicka",
    submit_success_tips: "Fixat!",
    submit_error_tips: "Operation misslyckades, försök igen",
    get_data_fail_tips: "Nätverksproblem, försök igen",
    use_other_verification_type_text: "Andra verifikationsmetoder",
    custom_support_notice:
        "Kontot har ingen säkerhetsinformation. Gå till följande länk i din dator för att ansöka." +
        process.env.VUE_APP_ORIGIN_PROFILE
};
